

<template></template>
  
  
  <script>
  import { useRoute } from 'vue-router';
  import { useRouter } from 'vue-router';
  export default {
    name: 'SetToken',
    async mounted() {
        const route = useRoute();
        const router = useRouter();
        localStorage.setItem('api_token', route.query.token);
        localStorage.setItem('current_user_id', route.query.userId);
        if (route.query.userTypeId == 2) {
            window.location.href = '/dashboard-hospital';
        } else {
            window.location.href = '/dashboard-institute';
        }
    }
  };
  </script>
  